<template>
  <div>
    <zj-layout-container>
      <zj-layout-main>
        <div class="zj-vehicleview-root select-none">
          <MapView
            MapKey="DefaultMap"
            @layerButtonClick="layerButtonClick"
          ></MapView>
        </div>
      </zj-layout-main>
    </zj-layout-container>
    <el-dialog
      class="map_popup_dialog"
      destroy-on-close="true"
      top="30vh"
      :visible.sync="isVideoMonitorDialogVisible"
      title="实时监控"
    >
      <zj-camera-preview
        class="videoBig-item"
        :cameraId="cameraId"
        :cameraName="cameraName"
        :autoplay="autoplay"
        :streamType="streamType"
        :cameraIsOnline="cameraIsOnline"
      />
    </el-dialog>
  </div>
</template>

<script>
import MapView from "./components/MapView";

export default {
  name: "IndexView",
  componentName: "IndexView",
  components: {
    MapView,
  },
  controller: "Home",
  action: "Index",
  data() {
    return {
      isVideoMonitorDialogVisible: false,
      streamType: 1, //0 - 主码流；1 - 子码流
      autoplay: true,
      cameraId: "",
      cameraName:"",
      cameraIsOnline:true,
    };
  },
  methods: {
    layerButtonClick: function(data) {
      let e = data.e;
      switch (data.action) {
        case "videomonitor":
          this.cameraId = e.data.DeviceId;
          this.cameraName = e.data.DeviceName;
          this.cameraIsOnline = e.data.IsOnline;
          this.isVideoMonitorDialogVisible = true;
          break;
        default:
          this.$message({ type: "warning", message: data.action + "未实现" });
          break;
      }
    },
  },
};
</script>

<style scoped>
.zj-vehicleview-root {
  height: 100%;
  width: 100%;
}
</style>
